// @ts-ignore
import {Observable} from "rxjs";
// @ts-ignore
import {map} from "rxjs/operators";
// @ts-ignore
import {ajax} from "rxjs/ajax";

// https://blog.garstasio.com/you-dont-need-jquery/ajax/#posting

export class HttpClient {

    constructor() {}

    post<T>(url:string) :Observable<T> {
        return ajax.post(url, null, null).pipe(
            map(p => <T> p.response)
        );
    }

    toJSON<T>(formData:FormData): T {
        if(formData != undefined) {

            let basis = new Object();
            formData.forEach((value, key, parent) => {
                basis[key] = value;
            });
            return <T> basis;
        }
    }

    postFormAsJson<T>(url :string, form :FormData) :Observable<T>{
        return ajax.post(url, this.toJSON(form), this.postHeaders().headers).pipe(
            map(p => <T> p.response)
        );
    }

    postForm<T>(url :string, form :FormData) :Observable<T>{
        return ajax.post(url, form, this.formPostHeaders().headers).pipe(
            map(p => <T> p.response)
        );
    }

    get<T>(url:string) :Observable<T> {
        return ajax.get(url, this.getHeaders().headers).pipe(
            map(p => <T> p.response)
        );
    }

    protected getHeaders() {
        return {
            headers: {
                method: 'POST',
                'Content-Type': 'application/json',
            }
        };
    }

    protected postHeaders() {
        return {
            headers: {
                method: 'POST',
                'Content-Type': 'application/json',
            }
        };
    }

    protected formPostHeaders() {
        return {
            headers: {
                method: 'POST',
                'enctype': 'multipart/form-data',
            }
        };
    }

}
